import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/PageContent";
import getToken from "app/api/getToken";
import { IPageContentShort } from "app/api/types";

export const GET_PAGE_CONTENT_SHORT_REQUEST = "GET_PAGE_CONTENT_SHORT_REQUEST";
export const GET_PAGE_CONTENT_SHORT_SUCCESS = "GET_PAGE_CONTENT_SHORT_SUCCESS";
export const GET_PAGE_CONTENT_SHORT_FAIL = "GET_PAGE_CONTENT_SHORT_FAIL";

export const getShortPageContent = () => (dispatch: any): any => {
  dispatch({ type: GET_PAGE_CONTENT_SHORT_REQUEST });

  const token = getToken();

  return api
    .getShortPageContent(token)
    .then((response: AxiosResponse) => {
      const pageContentList: IPageContentShort[] = get(response, "data", {});
      dispatch({
        type: GET_PAGE_CONTENT_SHORT_SUCCESS,
        payload: pageContentList
      });

      return pageContentList;
    })
    .catch(err => {
      dispatch({
        type: GET_PAGE_CONTENT_SHORT_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
